export default "__VITE_ASSET__Cl4nG9OH__"